export default {
  label: 'Chat med vores team',
  label_unread: 'Chat med vores team, {{count}} nye',
};
